import { useTheme } from "hooks/useTheme";
import { ReactNode } from "react";

type Props = {
  id?: string;
  body: ReactNode;
  direction: "in" | "out";
  index: number;
  dataLength: number;
  refProp?: any;
  lastElementRef?: any;
  clinicDetails: any;
  chatwidget_image_url?: string;
};

const ChatBubble = ({
  index,
  dataLength,
  refProp,
  lastElementRef,
  clinicDetails,
  id,
  body,
  direction,
  chatwidget_image_url,
}: Props) => {
  const theme = useTheme();
  return (
    <div
      id={index === 0 ? "scroll-into-view" : ""}
      className={
        direction === "out"
          ? "message incoming-message"
          : "message outgoing-message"
      }
      key={id || index}
      ref={dataLength === index + 1 ? refProp : lastElementRef}
    >
      {direction === "out" && (
        <div className="i-img" style={{ backgroundColor: theme.incomingIcon }}>
          {clinicDetails?.initials}
        </div>
      )}

      <style>
        {`
         .pointer-color::after {
           border-left-color: ${theme.primary} !important;
         }
        `}
      </style>

      <div
        className={
          direction === "out" ? "i-message " : "o-message pointer-color"
        }
        style={{
          backgroundColor: direction === "in" ? theme.primary : "#d3d0d0",
          borderColor: direction === "in" ? theme.primary : "#d3d0d0",
        }}
      >
        {body}
        {chatwidget_image_url && (
          <>
            <br />
            <img
              src={chatwidget_image_url}
              height={100}
              alt=""
              width={100}
              style={{
                border: "1px solid #5e5b5b",
                marginBottom: 10,
                marginTop: 10,
                borderRadius: 10,
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ChatBubble;
